import React, { useState, useEffect } from "react";
import {
  Box, Paper, Typography, MenuItem, FormControl, Select, InputLabel,
  Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Grid,
  TextField, TablePagination
} from "@mui/material";
import ButtonMain from "../Button";
import httpClient from "../../_util/api";
import dateFormat from "../../Helpers/DateFormat";

const reportOptions = [
  { label: "Pending", value: "pending" },
  { label: "Process", value: "process" },
  { label: "Approved", value: "approved" },
  { label: "Paid", value: "paid" },
  { label: "Rejected", value: "rejected" },
  { label: "Completed", value: "completed"},
];

const Applications = () => {
  const [mainCategory, setMainCategory] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const getAllApplications = async (pageNumber = page, limit = rowsPerPage) => {
    try {
      const res = await httpClient.get("/students/getApplications", {
        params: {
          page: pageNumber + 1,
          limit,
          fromDate: dateFormat(fromDate),
          toDate: dateFormat(toDate),
          mainCategory,
          searchQuery,
        },
      });

      if (res.status === 200) {
        setData(res.data.data);
        setTotalCount(res.data.total);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAllApplications();
  }, [page, rowsPerPage]);

const handleDownload = () => {
  const csvData = [
    [
      "Application No",
      "Name",
      "Email",
      "Institution",
      "Semester",
      "Tuition Fee",
      "Submission Date",
      "Status"
    ],
    ...data.map((item) => [
      item.applicationNumber,
      item.studentName,
      item.email,
      item.otherInstitutionName || item.institutionName,
      item.grade,
      item.tuttionFee,
      item.applicationSubmitDate,
      item.status
    ])
  ];

  const csvContent = csvData.map(row =>
    row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(",")
  ).join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `${mainCategory || "report"}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleGetAllValues = () => {
  setPage(0); 
  getAllApplications(0);
};

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClearFilters = () => {
    setMainCategory("");
    setFromDate("");
    setToDate("");
  }
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, pr: 3 }}>
        <Typography variant="h6" fontWeight="bold">Reports Overview</Typography>
        <ButtonMain onClick={handleDownload}>Download CSV</ButtonMain>
      </Box>

      <Paper sx={{ p: 3, mt: 2 }}>
        <Grid container spacing={2} sx={{ mb: 2, alignItems: "end" }}>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={mainCategory}
                onChange={(e) => setMainCategory(e.target.value)}
                label="Status"
              >
                {reportOptions.map((option) => (
                  <MenuItem key={option.label} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="From Date"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="To Date"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Box display="flex" gap={1}>
              <ButtonMain onClick={handleGetAllValues}>Get Values</ButtonMain>
              <ButtonMain variant="white" onClick={handleClearFilters}>Clear Filters</ButtonMain>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 3, mt: 2 }}>
        <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Search by Name or Email"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleGetAllValues()}
              fullWidth
            />
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
           <Table>
          <TableHead sx={{ backgroundColor: "#4caf50" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Application No</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Institution</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Semester</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Tuition Fee</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Submission Date</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                key={index}
              >
                <TableCell>{item.applicationNumber}</TableCell>
                <TableCell>{item.studentName}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{item.otherInstitutionName || item.institutionName}</TableCell>
                <TableCell>{item.grade}</TableCell>
                <TableCell>{item.tuttionFee}</TableCell>
                <TableCell>{item.applicationSubmitDate}</TableCell>
                <TableCell
                  style={{
                    textTransform: 'capitalize',
                    color: item.status === 'rejected' ? 'red' : 'inherit'
                  }}
                >
                  {item.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Paper>
    </>
  );
};

export default Applications;
